import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useSessionStorage from "./useSessionStorage";
import "./Player.css";
import useAxios from "./useAxios";
import "./FormStyles.css";

const Player = () => {
  const { id } = useParams();
  const [player, setPlayer] = useState({
    name: "",
    handicaps: [],
    tenant: null,
  });
  const [handicapTypes, setHandicapTypes] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [axios] = useAxios(true);
  const navigate = useNavigate();
  const [tenant] = useSessionStorage("tenant");

  useEffect(() => {
    const fetchData = async () => {
      // Fetch game types first
      await axios.get("gametypes", setHandicapTypes);
      // Then fetch player data
      await axios.get("player/" + id, (data) => {
        // Ensure all game types are represented
        const allHandicaps = handicapTypes.map(type => {
          const existing = data.handicaps?.find(h => h.gameTypeId === type.id);
          return existing || { gameTypeId: type.id, gameTypeDescription: type.description, value: 0 };
        });
        setPlayer({ ...data, handicaps: allHandicaps });
      });
      if (tenant?.super) {
        await axios.get("tenants", setTenants);
      }
    };
    fetchData();
  }, [handicapTypes.length]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlayer((prev) => ({ ...prev, [name]: value }));
  };

  const handleHandicapChange = (gameTypeId, value) => {
    setPlayer((prev) => ({
      ...prev,
      handicaps: prev.handicaps.map(h =>
        h.gameTypeId === gameTypeId ? { ...h, value: parseInt(value) || 0 } : h
      )
    }));
  };

  const handleTenantChange = (e) => {
    const { value } = e.target;
    const selectedTenant = tenants.find((t) => t.id === value);
    setPlayer((prev) => ({ ...prev, tenant: selectedTenant }));
  };

  const onSave = () => {
    const payload = { ...player };
    if (tenant?.super) {
      payload.tenant = tenants.find((t) => t.id === player.tenant?.id);
    } else {
      payload.tenant = tenant;
    }
    axios.post("player/" + id, payload, onCancel);
  };

  const onCancel = () => {
    navigate("/configuration/players");
  };

  if (player === null) {
    return <h1>Loading</h1>;
  }

  return (
    <div className="edit-player-form">
      <h2>Edit Player</h2>
      <form className="player-form-fields">
        {tenant?.super && (
          <div className="form-group">
            <label htmlFor="tenant">Tenant:</label>
            <select
              name="tenant"
              id="tenant"
              value={player.tenant?.id || ""}
              onChange={handleTenantChange}
              required
              className="form-control"
            >
              <option value="">Select a tenant</option>
              {tenants.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="name"
            id="name"
            value={player.name}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        {player.handicaps.map((handicap) => (
          <div className="form-group" key={handicap.gameTypeId}>
            <label htmlFor={`handicap-${handicap.gameTypeId}`}>
              {handicap.gameTypeDescription} Handicap:
            </label>
            <input
              type="number"
              id={`handicap-${handicap.gameTypeId}`}
              value={handicap.value}
              onChange={(e) => handleHandicapChange(handicap.gameTypeId, e.target.value)}
              className="form-control"
            />
          </div>
        ))}
        <div className="form-buttons">
          <button type="button" onClick={onSave} className="submit-button">
            Save
          </button>
          <button type="button" onClick={onCancel} className="cancel-button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Player;
